// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDelinquentClaimsMetricsResponseDto
 */
export interface IDelinquentClaimsMetricsResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IDelinquentClaimsMetricsResponseDto
     */
    show_delinquent_claims_metrics?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsMetricsResponseDto
     */
    paid_requiring_docs_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsMetricsResponseDto
     */
    repayment_required_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsMetricsResponseDto
     */
    locked_purses_count?: number;
}

/**
 * Check if a given object implements the IDelinquentClaimsMetricsResponseDto interface.
 */
export function instanceOfIDelinquentClaimsMetricsResponseDto(value: object): value is IDelinquentClaimsMetricsResponseDto {
    return true;
}

export function IDelinquentClaimsMetricsResponseDtoFromJSON(json: any): IDelinquentClaimsMetricsResponseDto {
    return IDelinquentClaimsMetricsResponseDtoFromJSONTyped(json, false);
}

export function IDelinquentClaimsMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDelinquentClaimsMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'show_delinquent_claims_metrics': json['show_delinquent_claims_metrics'] == null ? undefined : json['show_delinquent_claims_metrics'],
        'paid_requiring_docs_count': json['paid_requiring_docs_count'] == null ? undefined : json['paid_requiring_docs_count'],
        'repayment_required_count': json['repayment_required_count'] == null ? undefined : json['repayment_required_count'],
        'locked_purses_count': json['locked_purses_count'] == null ? undefined : json['locked_purses_count'],
    };
}

export function IDelinquentClaimsMetricsResponseDtoToJSON(json: any): IDelinquentClaimsMetricsResponseDto {
    return IDelinquentClaimsMetricsResponseDtoToJSONTyped(json, false);
}

export function IDelinquentClaimsMetricsResponseDtoToJSONTyped(value?: IDelinquentClaimsMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'show_delinquent_claims_metrics': value['show_delinquent_claims_metrics'],
        'paid_requiring_docs_count': value['paid_requiring_docs_count'],
        'repayment_required_count': value['repayment_required_count'],
        'locked_purses_count': value['locked_purses_count'],
    };
}

